import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock-in-start-filled",
  "use": "clock-in-start-filled-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"clock-in-start-filled\"><path fill-rule=\"evenodd\" d=\"M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 14.545A6.553 6.553 0 0 1 1.455 8 6.553 6.553 0 0 1 8 1.455 6.553 6.553 0 0 1 14.545 8 6.553 6.553 0 0 1 8 14.545\" clip-rule=\"evenodd\" /><circle cx=\"8\" cy=\"8\" r=\"8\" /><path fill=\"#fff\" d=\"m12 8-6 3.464V4.536z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol